import cn from 'classnames';
import React from 'react';
import { InstanceProps, create } from 'react-modal-promise';

import { useTranslation } from 'next-i18next';
import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';

import stylesContent from 'components/candidate/RegistrationDetailsModal/RegistrationForm.module.scss';
import styles from './DisableRequireApprovalModal.module.scss';

const ModalInstance: React.FC<InstanceProps<boolean | null>> = ({
  isOpen,
  onResolve,
  onReject,
}) => {
  const [t] = useTranslation('community');
  const [tCommon] = useTranslation('common');
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onReject}
      contentClassName={cn(styles.container, {})}
      className={styles.modal}
    >
      <div className={stylesContent.RegistrationForm}>
        <div className={cn(stylesContent.section, stylesContent.top)}>
          <div className={styles.header}>
            <div className={styles.headerWrapper}>
              <p className={styles.title}>
                {t('disable-require-approval-modal-title')}
              </p>
              <IconButton
                size="small"
                iconName="close"
                className={stylesContent.cancelIcon}
                onClick={() => onReject()}
              />
            </div>
          </div>
        </div>
        <div className={styles.desc}>
          {t('disable-require-approval-modal-description')}
        </div>
        <div className={cn(stylesContent.section, stylesContent.bottom)}>
          <div className={stylesContent.separator}></div>
          <div className={styles.footer}>
            <ButtonV3
              size="medium"
              type="submit"
              className={styles.button}
              onClick={() => onResolve(true)}
            >
              {tCommon('ok').toUpperCase()}
            </ButtonV3>
            <ButtonV3
              color="secondary"
              size="medium"
              className={styles.button}
              onClick={() => onReject()}
            >
              {tCommon('cancel')}
            </ButtonV3>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const DisableRequireApprovalModal = create(ModalInstance);
